import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { map, take } from 'rxjs';
import {
  BasePasswordFormComponent,
  fieldErrorMap,
  sharedPasswordValidators,
} from 'password-validations';
import { ResetPasswordComponentStore } from './reset-password.component-store';
import { Severity } from 'graphql-api/baskets-api-interfaces';

@Component({
  selector: 'epc-auth-reset-password',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  providers: [ResetPasswordComponentStore],
  standalone: false,
})
export class ResetPasswordComponent extends BasePasswordFormComponent {
  private route = inject(ActivatedRoute);
  private fb = inject(UntypedFormBuilder);
  private componentStore = inject(ResetPasswordComponentStore);

  public severity = Severity;

  public fieldErrorMap = fieldErrorMap;

  public error$ = this.componentStore.error$;

  public passwordForm: UntypedFormGroup = this.fb.group(
    {
      newPassword: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]],
    },
    {
      validators: sharedPasswordValidators,
    },
  );

  private resetParams$ = this.route.queryParams.pipe(
    map((params: Params) => {
      const { userId, token } = params;
      return { userId, passwordToken: token };
    }),
  );

  public sendRequest() {
    if (this.passwordForm.invalid) return;

    this.resetParams$.pipe(take(1)).subscribe((params) => {
      const formValue = this.passwordForm.value;
      this.componentStore.resetPassword({
        // migrated from old solution
        oldPassword: 'whateverman',
        ...formValue,
        ...params,
      });
    });
  }
}
